module.exports = __webpack_public_path__ + "static/media/scottsboro.a07563c4.jpg";